import React from 'react';
import { Progress } from '@/components/ui/progress';

interface EnergyGaugeProps {
  value: number;
  zone: 'green' | 'orange' | 'red';
}

export function EnergyGauge({ value, zone }: EnergyGaugeProps) {
  const getZoneColor = () => {
    switch (zone) {
      case 'green': return 'bg-green-500';
      case 'orange': return 'bg-orange-500';
      case 'red': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium">Niveau d'énergie</span>
        <span className={`text-sm font-bold ${
          zone === 'green' ? 'text-green-600' :
          zone === 'orange' ? 'text-orange-600' : 'text-red-600'
        }`}>
          {value}%
        </span>
      </div>
      <Progress
        value={value}
        className={`h-3 ${getZoneColor()}`}
      />
    </div>
  );
}